module.exports = __webpack_public_path__ + "static/media/LogoCamaCam.2d4d14f0.png";